
import { useState } from "react";
import { useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro'
import { MainPageTitle, PageExplainer } from "./EpimsStyledComponents";

function ApiEpcReview({selectedCertificate, acceptEpc})
{
    const [loading, setLoading] = useState(true)
    const [epcFound, setEpcFound] = useState(false)
    const [summaryData, setSummaryData] = useState([])
    const [cTaxData, setCTaxData] = useState([])

    useEffect(() => {
        if (selectedCertificate !== null) {
            setLoading(true)
            setEpcFound(false)
            const url = process.env.REACT_APP_API_END_POINT + 'fetchepc';
            fetch(url, {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                method: "POST",
                body: JSON.stringify({
                    selectedCertificate
                }),
                credentials: "include"
            })
            .then((resp) => resp.json())
            .then((data) => {
                if (data['success']) {
                    setLoading(false)
                    if (data['epcFound']) {
                        setEpcFound(true)
                        setSummaryData(data['data'])
                        setCTaxData(data['data']['cTax'])
                    } else {
                        setEpcFound(false)
                    }                    
                } else {

                } 
            });
        }
    }, [selectedCertificate])

    if (loading) return <div><FontAwesomeIcon className="spinner-slow" icon={solid("spinner")} style={{color: "#000000", height: "100px", width: "100px" }} /></div>

    if (!epcFound) return (
        <div style={{marginTop: "16px"}}>
            <p>We couldn't find a valid EPC for that property.</p>
            <p>If the EPC was lodged very recently, please try again tomorrow.</p>
        </div>
    )

    return (
        <div style={{maxWidth: "800px", marginInline: "auto", display: "flex", flexDirection: "column", marginTop: "32px"}}>
            <MainPageTitle>Check EPC details</MainPageTitle>
            <PageExplainer>
                We fetched the EPC you selected, please check the details match what you expect. If the EPC was lodged very recently and was not listed, please wait a day or so and try again.
            </PageExplainer>
            <div className="epcSummary">
                <p><strong>Certificate number: </strong>{summaryData['certificateNumber']}</p>
                <p><strong>Address:-</strong></p>
                <p>{summaryData['addressLine1']}</p>
                <p>{summaryData['addressLine2']}</p>
                <p>{summaryData['addressLine3']}</p>
                <p>{summaryData['addressLine4']}</p>
                <p>{summaryData['postTown']}</p>
                <p>{summaryData['postcode']}</p>
                <p><strong>EPC Band: </strong> {summaryData['currentEnergyEfficiencyBand']}</p>
                <p><strong>Registration date: </strong> {summaryData['registrationDate']}</p>
                {!summaryData['schemaTypeSupported'] && <>
                    <p><strong>Generated using : </strong>{summaryData['schemaType']} {summaryData['schemaTypeSupported'] ? <><FontAwesomeIcon style={{marginLeft: "20px"}} icon={solid("check")} /> Supported by epIMS</> : <><FontAwesomeIcon style={{marginLeft: "20px"}} icon={solid("x")} /> Not supported by epIMS</>}</p>
                </>}
                <br/>
                {summaryData['schemaTypeSupported'] && <>
                    <button className="btn btn-primary" style={{display: "flex", marginInline: "auto", minWidth: "200px", justifyContent: "center"}} onClick={() => acceptEpc(cTaxData, summaryData['certificateNumber'])}>Continue</button>
                </>
                }
            </div>
        </div>
    )
}

export default ApiEpcReview;